import documentTemplatesService from "@/services/documentTemplatesService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      const res = await documentTemplatesService.create(formData);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Dokumentvorlage konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }) {
    try {
      const res = await documentTemplatesService.findAll();
      commit("setAll", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Dokumentvorlage konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findOne({ commit, dispatch }, { id }) {
    try {
      const res = await documentTemplatesService.findOne({ id });
      commit("setSingle", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Dokumentvorlage konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await documentTemplatesService.delete({ id });
      dispatch("findAll");
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Dokumentvorlage konnten nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, { id, formData }) {
    try {
      await documentTemplatesService.update({ id, formData });
      dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Dokumentvorlage wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Dokumentvorlage konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  }
};


const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
